import { faker } from '@faker-js/faker';

import type { VerifyUserAttributePostResponse } from '../types/VerifyUserAttributePostResponse';

export function createVerifyUserAttributePostResponse(
  data: NonNullable<Partial<VerifyUserAttributePostResponse>> = {}
): NonNullable<VerifyUserAttributePostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
